(function () {
    'use strict';

    angular.module('UndergroundWebApp').controller('DeviceDetailsModalController', DeviceDetailsModalController);

    DeviceDetailsModalController.$inject = [
        '$scope', 
        '$q', 
        '$windowInstance', 
        'formTypes', 
        'currentFormType', 
        'externalSystemsService', 
        'deviceService', 
        'guidService', 
        'containerId', 
        'device', 
        'updateCallbacks', 
        'deviceTypes', 
        'fallbackErrorMessageText',
        'reportfrequenceList',
        '$translate',
        // 'batteryTypeService'
    ];

    function DeviceDetailsModalController(
        $scope, 
        $q, 
        $windowInstance, 
        formTypes, 
        currentFormType, 
        externalSystemsService, 
        deviceService, 
        guidService, 
        containerId, 
        device, 
        updateCallbacks, 
        deviceTypes, 
        fallbackErrorMessageText,
        reportfrequenceList,
        $translate,
        // batteryTypeService
        ) {

        $scope.externalSystem = '';
        $scope.externalId = '';
        $scope.serial = '';
        $scope.sensorHeight = '';
        $scope.fullHeight = '';
        $scope.customerKey = '';
        $scope.isPriority = false;
        $scope.on = $translate.instant('G_TRUE');
        $scope.off = $translate.instant('G_FALSE');

        $scope.save = save;
        $scope.saveAndClose = saveAndClose;
        $scope.close = close;

        $scope.externalSystemValid = true;
        $scope.externalIdValid = true;
        $scope.deviceTypeValid = true;
        $scope.rapporteringsValid = true;
        $scope.actuatortypeValid = true;
        $scope.holdtimeValid = true;

        $scope.reportfrequenceListOptions = {
            dataSource: new kendo.data.DataSource({
                transport: {
                    read: readReportFrequencyList
                }
            }),
            dataTextField: 'text',
            dataValueField: 'id',
        };

        // $scope.batteryTypeListOptions = {
        //     dataSource: new kendo.data.DataSource({
        //         transport: {
        //             read: readBatteryTypeList
        //         }
        //     }),
        //     dataTextField: 'name',
        //     dataValueField: 'id',
        // };

        if (formTypes.edit === currentFormType && device) {
            $scope.isEdit = true;
            $scope.selectedExternalSystemId = device.externalSystemId;
            $scope.externalId = device.externalId;
            $scope.serial = device.serial;
            $scope.sensorHeight = device.sensorHeight;
            $scope.fullHeight = device.fullHeight;
            $scope.customerKey = device.customerKey;
            $scope.isActive = device.isActive;
            $scope.isPriority = device.isPriority;
            $scope.selectedDeviceType = _.find(deviceTypes, { id: device.deviceType });
            $scope.selectedReportFrequence = {id: device.reportFrequency};
            $scope.isSound = device.isSoundEnabled;
            $scope.selectedHoldtime = device.holdTime;
        }

        initController();
        
        function initController() {
            externalSystemsService.getExternalSystems().then(systems => {
                $scope.externalSystems = systems;
                $scope.selectedExternalSystem = _.find($scope.externalSystems, s => s.id.toLowerCase() == $scope.selectedExternalSystemId)
                $scope.externalSystemOptions = {
                    dataSource: {
                        transport: {
                            read: (e) => e.success(systems ? systems : [])
                        }
                    },
                    dataTextField: 'name',
                    dataValueField: 'id',
                    change: function (e) {
                        $scope.selectedExternalSystemId = this.value();
                    }
                };

                $scope.deviceTypeOptions = {
                    dataSource: {
                        transport: {
                            read: readDeviceTypes
                        }
                    },
                    dataTextField: 'localizedName',
                    dataValueField: 'id',
                    optionLabel: {
                        localizedName: $translate.instant("DEVICE_DETAILS_CONTROLLER_CHOOSE_TYPE"),
                        id: '',
                    },
                };
            }).catch(function (error) {
                $scope.extSystemsDdlServerErrorText = error.localizedMessage || fallbackErrorMessageText;
            });
        }

        function close() {
            $windowInstance.close();
        }

        function save() {
            $scope.externalSystemValid = !!$scope.selectedExternalSystem;
            $scope.externalIdValid = !!$scope.externalId;
            $scope.deviceTypeValid = !!$scope.selectedDeviceType &&
                $scope.selectedDeviceType.id !== '';

            var deferred = $q.defer();
            
            var deviceDto = {
                id: device ? device.id : guidService.emptyGuid(),
                externalId: $scope.externalId,
                serial: $scope.serial,
                customerKey: $scope.customerKey,
                externalSystem: $scope.selectedExternalSystem,
                externalSystemId: $scope.selectedExternalSystem.id,
                sensorHeight: $scope.sensorHeight,
                fullHeight: $scope.fullHeight,
                containerId: containerId,
                isActive: $scope.isActive,
                isPriority: $scope.isPriority,
                deviceType: $scope.selectedDeviceType.id,

                reportFrequency: $scope.selectedReportFrequence.id,
                isSoundEnabled: $scope.isSound, 
                actuatorType: $scope.selectedActuatortype && $scope.selectedActuatortype.id, 
                holdTime: $scope.selectedHoldtime,
                // batteryType: $scope.selectedBatteryType,
            }

            if ($scope.externalSystemValid && $scope.externalIdValid && $scope.deviceTypeValid) {
                if ($scope.isEdit) {
                    deviceService.updateDevice(deviceDto).then((updatedDevice) => {
                        device = updatedDevice;
                        if (updateCallbacks && updateCallbacks.updateDeviceToGrid) {
                            var gridDevice = {...device};
                            gridDevice.externalSystem = $scope.selectedExternalSystem.name;
                            updateCallbacks.updateDeviceToGrid(gridDevice);
                        }

                        deferred.resolve();
                    });
                } else {
                    deviceService.addDevice(deviceDto).then((addedDevice) => {
                        device = addedDevice;
                        $scope.isEdit = formTypes.edit;
                        if (updateCallbacks && updateCallbacks.addDeviceToGrid) {
                            var gridDevice = {...device};
                            gridDevice.externalSystem = $scope.selectedExternalSystem.name;
                            updateCallbacks.addDeviceToGrid(gridDevice);
                        }
                        deferred.resolve();
                    });
                }
            }

            return deferred.promise;
        }

        function saveAndClose() {
            if($scope.selectedDeviceType.name == 'Access' 
                && (parseInt($scope.selectedHoldtime) < 5 || parseInt($scope.selectedHoldtime) > 126)) {
                return;
            } 
            save()
                .then(() => {
                    close();
                }).catch(() => {
                    alert($translate.instant("G_SAVE_FAILED"));
                });
        }


        function readReportFrequencyList(e){
            e.success(reportfrequenceList);
        }
        
        function readBatteryTypeList(e){
            batteryTypeService.getBatteryTypes().then(result => {
                $scope.batteryTypeList = result;
                $scope.selectedBatteryType = device.batteryTypeId ? _.find($scope.batteryTypeList, { id: device.batteryTypeId }) : null;
                e.success($scope.batteryTypeList)
            },
            function () {
                e.success([]);
            });
        }
                
        function readDeviceTypes(e){
            e.success(deviceTypes);
        }

    }
})();

